(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      // Check if we're on PLP (collection) or PDP (product) page
      this.isPlpOrPdp = document.body.classList.contains('template-collection') || 
                        document.body.classList.contains('template-product') ||
                        window.location.pathname.includes('/collections/') ||
                        window.location.pathname.includes('/products/');
      
      // Enable hide-on-scroll for PLP/PDP when using 'hide-on-scroll-plp-pdp' option
      this.hideOnScrollPlpPdp = this.stickyType === 'hide-on-scroll-plp-pdp';



      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky || (this.hideOnScrollPlpPdp && !this.isPlpOrPdp)) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Hysteresis: minimum scroll distance before triggering hide/reveal
      this.scrollThreshold = 15;
      this.scrollDirectionChangePosition = 0;
      this.currentDirection = null;
      // Track if we've done the initial hide (first scroll down from top)
      this.initialHideDone = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Determine scroll direction
      const scrollingDown = scrollTop > this.currentScrollTop;
      const scrollingUp = scrollTop < this.currentScrollTop;
      const newDirection = scrollingDown ? 'down' : (scrollingUp ? 'up' : this.currentDirection);

      // Detect direction change
      if (newDirection !== this.currentDirection) {
        this.scrollDirectionChangePosition = this.currentScrollTop;
        this.currentDirection = newDirection;
      }

      // Calculate distance since direction change
      const scrollDistance = Math.abs(scrollTop - this.scrollDirectionChangePosition);
      const passedThreshold = scrollDistance >= this.scrollThreshold;



      if (scrollingDown && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        // Always sticky modes: never hide, just ensure sticky class
        if (this.headerIsAlwaysSticky) {
          this.currentScrollTop = scrollTop;
          return;
        }
        // Only hide on scroll for PLP/PDP when using hide-on-scroll-plp-pdp option
        // On other pages, header should stay sticky (like on-scroll-up behavior)
        if (this.hideOnScrollPlpPdp && !this.isPlpOrPdp) {
          // Not on PLP/PDP: just make sticky, don't hide
          this.header.classList.add('shopify-section-header-sticky');
          this.currentScrollTop = scrollTop;
          return;
        }
        // For initial hide (first time scrolling down from top), hide immediately
        if (!this.initialHideDone) {
          this.initialHideDone = true;
          // IMPORTANT: Add hidden TOGETHER with sticky to avoid flash
          // Also add initial-hide class to disable transition on first hide
          this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate', 'initial-hide');
          this.closeMenuDisclosure();
          this.closeSearchModal();
        } else if (passedThreshold) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollingUp && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        // Always sticky modes: header is always visible, nothing to do
        if (this.headerIsAlwaysSticky) {
          this.currentScrollTop = scrollTop;
          return;
        }
        // On non PLP/PDP pages with hide-on-scroll-plp-pdp, header is always visible
        if (this.hideOnScrollPlpPdp && !this.isPlpOrPdp) {
          this.header.classList.add('shopify-section-header-sticky');
          this.currentScrollTop = scrollTop;
          return;
        }
        if (!this.preventReveal) {
          if (passedThreshold) {
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          if (passedThreshold) {
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.initialHideDone = false;
        // Only remove sticky when exactly at the top (scrollTop <= 0) to avoid visual shift
        if (scrollTop <= 0) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // Block hide if always sticky, OR if using plp-pdp option but not on plp/pdp page
      if (this.headerIsAlwaysSticky) {
        return;
      }
      if (this.hideOnScrollPlpPdp && !this.isPlpOrPdp) {
        return;
      }
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        return;
      }
      if (this.hideOnScrollPlpPdp && !this.isPlpOrPdp) {
        return;
      }
      
      // Remove initial-hide so transition works when revealing
      this.header.classList.remove('initial-hide');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        return;
      }
      if (this.hideOnScrollPlpPdp && !this.isPlpOrPdp) {
        return;
      }
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'initial-hide');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });

    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
